import { Typography } from '@mui/material';
import { styled } from 'styled-components';

export const StyledContainer = styled.div<{ width?: string }>`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: ${(props) => props?.width || '20%'};
  height: 10%;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(31, 38, 135, 0.37); /* updated shadow */
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(17.5px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  gap: 24px;
`;


export const StyledText = styled(Typography)`
`;